import {
  Box,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack
} from '@chakra-ui/react'
import { GridView } from '@components/icons'
import { Computer } from '@material-ui/icons'
import React from 'react'

interface TelehealthSourceInfoModalProps {
  isOpen: boolean
  onClose: () => void
}

export const TelehealthSourceInfoModal: React.FC<
  TelehealthSourceInfoModalProps
> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxW="688px">
        <ModalHeader
          fontSize="18px"
          textAlign="center"
          borderBottom="1px solid"
          borderColor="pale_gray"
        >
          Desktop App vs. In Your Browser
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6} pt="32px">
          <VStack spacing={6} align="stretch">
            <Text>
              Understanding how you conduct your sessions allows us to capture
              the best possible audio from your client.
            </Text>

            <Box>
              <Box display="flex" alignItems="flex-start">
                <Box>
                  <Box display="flex">
                    <Icon
                      as={Computer}
                      boxSize={5}
                      color="black"
                      mr={2}
                      mt={1}
                    />
                    <Text fontWeight="bold" fontSize="md" mb={1}>
                      Desktop App:
                    </Text>
                  </Box>
                  <Text>
                    This is a program you download onto your computer. If your
                    telehealth session opens in its own window, separate from
                    your web browser, you're using a Desktop App. It usually has
                    its own icon on your desktop or taskbar.
                  </Text>
                </Box>
              </Box>
            </Box>

            <Box>
              <Box display="flex" alignItems="flex-start">
                <Box>
                  <Box display="flex">
                    <Icon
                      as={GridView}
                      boxSize={5}
                      color="black"
                      mr={2}
                      mt={1}
                    />
                    <Text fontWeight="bold" fontSize="md" mb={1}>
                      Web Browser:
                    </Text>
                  </Box>
                  <Text>
                    If your telehealth session opens inside a browser tab—just
                    like when you visit websites like Google, YouTube, or
                    Facebook—then you should select web browser.
                  </Text>
                </Box>
              </Box>
            </Box>

            <Box borderTop="1px solid" borderColor="pale_gray" pt={4}>
              <Text fontWeight="bold" fontSize="md" mb={2}>
                Zoom users:
              </Text>
              <Text>
                Oftentimes, a zoom link will initially bring you to a web
                browser with a button to "Launch meeting". Once you click this,
                the Desktop app will open. In this case, you should select
                "Desktop app".
              </Text>
            </Box>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
